import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import bobineEssuieMains from "@/assets/products/bobine-essuie-mains.png";

const config: ProductPageConfig = {
  name: "Bobines essuie-mains",
  breadcrumbName: "Bobines essuie-mains",
  subtitle: "Bobines d'essuie-mains à dévidage central, douces et absorbantes",
  features: ["Recyclable", "2 plis", "Dévidage central", "Disponible en stock"],
  variants: [
    { name: "1000 feuilles", material: "Papier recyclé 2 plis", packaging: "Colis de 6 bobines", palette: "75 colis", image: bobineEssuieMains },
  ],
};

const BobineEssuieMains = () => <ProductPageLayout config={config} />;
export default BobineEssuieMains;
